import { render, staticRenderFns } from "./Servidores.vue?vue&type=template&id=2b3f2c8e&"
import script from "./Servidores.vue?vue&type=script&lang=js&"
export * from "./Servidores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports